(() => {
    'use strict';

    angular
        .module('uwAgenda.users')
        .controller('GlobalInfoController', [
            '$uibModalInstance',
            'title',
            'body',
            GlobalInfoControllerFn]);

    function GlobalInfoControllerFn(
        $uibModalInstance,
        title,
        body) {
        let viewModel = this;

        viewModel.title = title;
        viewModel.body = body;
        
        viewModel.yes = () => {
            $uibModalInstance.close();
        };
    }
})();
